import { Form } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import Empty from "../common/Empty";
import moment from "moment";
import CustomerLayout from "./Layout";
import CustomerHeader from "./Layout/topHeader";

const DriverOrdersList = () => {
  const [status, setStatus] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [limit, setLimit] = useState(16);
  const [driversData, setdriversData] = useState({
    loading: false,
    data: null,
  });

  const [selectedUser, setSelectedUser] = useState(undefined);

  const route = useParams();

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const reseAllFieldData = () => {
    setStatus("");
    setMobileNumber("");
    form.resetFields();
  };

  const getUserOrders = useCallback(async () => {
    setdriversData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/order/by-delivery-man?` +
          `&deliveryManId=${(route as any)?.id || ``}` +
          `&page=${page || 0}` +
          `&limit=${limit || 16}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setdriversData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setdriversData({ loading: false, data: [] });
        console.error("Users: Error", err);
      });
  }, [route, page, limit]);

  useEffect(() => {
    getUserOrders();
  }, [getUserOrders]);

  return (
    <React.Fragment>
      <CustomerLayout driverId={(route as any)?.id as string}>
        <div className="bg-white">
          <CustomerHeader
            leftarea={"Delivered Orders History"}
            rightarea={""}
          />

          <div className="product-list-item-area white-bg section-padding-bottom">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-list-items-inner-content">
                    <div className="single-product-wrapper">
                      <div className="single-product-heading">
                        <span>Date & Time</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Order ID</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Status (DM)</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Status</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Method</span>
                      </div>
                      <div className="single-product-heading">
                        <span>SubTotal</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Total</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="row">
                {driversData?.loading ? (
                  <Loading />
                ) : (
                  <div className="col-lg-12 product-table">
                    <div className="product-table-area">
                      {driversData?.data?.orders?.length ? (
                        driversData?.data?.orders?.map(
                          (order: any, index: any) => (
                            <React.Fragment key={index}>
                              <div
                                className="single-product-wrapper"
                                onClick={() => setSelectedUser(order)}
                              >
                                <div className="single-product">
                                  <span className="name text-capitalize">
                                    {moment(order?.createdAt).format("lll")}
                                  </span>
                                </div>
                                <div className="single-product">
                                  <span className="name">{order?.orderId}</span>
                                </div>
                                {/* <div className="single-product">
                                <span className="name">
                                  {order?.statusOfMerchant}
                                </span>
                              </div> */}
                                <div className="single-product">
                                  <span
                                    className={`radius-btn ${order?.statusOfDeliveryMan?.toLowerCase()}-btn`}
                                  >
                                    {order?.statusOfDeliveryMan}
                                  </span>
                                </div>
                                <div className="single-product">
                                  <span
                                    className={`text-nowrap radius-btn ${order?.status?.toLowerCase()}-btn`}
                                  >
                                    {order?.status?.split("_").join(" ")}
                                  </span>
                                </div>

                                <div className="single-product">
                                  <span className="name">
                                    {order?.paymentMethod
                                      ?.split("_")
                                      .join(" ")
                                      .toUpperCase()}
                                  </span>
                                </div>
                                <div className="single-product">
                                  <span className="name">
                                    &#2547;{order?.subTotal}
                                  </span>
                                </div>
                                <div className="single-product">
                                  <span className="name">
                                    &#2547;{order?.total}
                                  </span>
                                </div>
                              </div>
                            </React.Fragment>
                          )
                        )
                      ) : (
                        <Empty data="Orders" />
                      )}
                    </div>
                  </div>
                )}
              </div>

              <PaginationTwo
                {...driversData?.data}
                limit={limit}
                page={getPage(loc.search)}
              />
            </div>
          </div>
        </div>
      </CustomerLayout>
    </React.Fragment>
  );
};

export default DriverOrdersList;
